module.exports = "/static/assets/3e834216ad9aa6769a6db38654b21b8c.png";